import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable } from '@macs-frontend/decorators';
import { Store } from '@ngrx/store';

export interface ButtonConfig {
  title: string;
  primary?: boolean;
  close?: boolean;
}

@Component({
  selector: 'md-modal-right',
  templateUrl: 'modal-right.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalRightComponent extends BaseComponent {
  @Input()
  show = false;

  @Input()
  buttons: Record<string, ButtonConfig> = {};

  @Input()
  showLoader = false;

  @Output()
  buttonPress = new EventEmitter<string>();

  @Output()
  closeModal = new EventEmitter();

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  close() {
    this.show = false;
    this.closeModal.emit();
  }

  onButtonPress(buttonId: string) {
    if (this.buttons[buttonId].close) {
      this.close();
    }
    this.buttonPress.emit(buttonId);
  }
}
